<script setup lang="ts">
/**
 * UI-kit component
 * Category: Logos
 * Name: AppLogo
 * FIGMA: https://www.figma.com/design/n8yjfgcFUgYPq4BLYjeYcJ/Design-System--Client?node-id=4087-114535&m=dev
 */
import { Logo } from '@brighterly/lib-lumee-ui'

import type { AppLogoProps } from './interfaces'

defineOptions({
  name: 'AppLogo',
})

withDefaults(defineProps<AppLogoProps>(), {
  type: 'full',
  color: 'main',
  size: 'md',
})
</script>

<template>
  <Logo
    brand="new"
    :type="type"
    :color="color"
    :size="size"
  />
</template>
